import { DisclosurePanel } from '@headlessui/react';

const PolicyCardContent: React.FC = ({ children }) => (
  <DisclosurePanel className="px-4">{children}</DisclosurePanel>
);

export default PolicyCardContent;
